import Vue from 'vue'
import App from './App.vue'

var vueScormPlayer = require("vue-scorm-player")

Vue.component('vue-scorm-player', vueScormPlayer)

Vue.config.productionTip = false

window.app = new Vue({
  render: h => h(App)
}).$mount('#app')
